function state() {
  return {
    notifications: [],
    networkError: false,
  };
}

export default state;
